import React from 'react';
import Select from '../../../../components/UI/Select';
import { TriggerType } from '../../../../store/evaluation/types';
import styles from './Filters.module.scss';

interface Props {
  value: string;
  onChange: (value: string | undefined) => void;
}

const TriggerTypeFilter: React.FC<Props> = ({ value, onChange }) => {
  const options = [
    { value: '', label: 'All Trigger Types' },
    ...Object.values(TriggerType).map((type) => ({ value: type, label: type })),
  ];

  return (
    <Select<string>
      label="Trigger Type"
      options={options}
      value={value}
      onChange={onChange}
      className={styles.filter}
    />
  );
};

export default TriggerTypeFilter;
